import { Grid, Divider } from '@mui/material';
import DataTableGrid from './DataTableGrid';
import Box from '@mui/material/Box';
import { landingPageMainDivStyle } from '../../../style/Styles';
import { Unauthorized } from '../../components/UnAuthorized';
import { useSelector } from 'react-redux';
import { AppState } from '../../store/AppStore';

export function LandingPage() {
  const user = useSelector((state: AppState) => state.user);

  if (!user.details) {
    return <Unauthorized />;
  }

  return (
    <Box sx={landingPageMainDivStyle.landingBox} className="w-100">
      <Divider className="divider" />
      <Grid container>
        <DataTableGrid />
      </Grid>
    </Box>
  );
}
